import EventBus from "../components/event-bus";
import {HTTP} from '../http-common';
import moment from 'moment';
import timezone from 'moment-timezone';

//import moment from 'moment';

export const commonMixins = {

    data: () => ({
        roleId : 0,
        activeMenu : '',
    }),
    mounted: function () {
        var self = this;

        /* self.adjustTableHeight();
        window.addEventListener('resize', self.adjustTableHeight); */

    },
    created() {

    },
    beforeMount() {

    },
    beforeDestroy() {
        // window.removeEventListener('resize', this.adjustTableHeight);
    },
    computed: {
    },

    watch: {
    },

    methods: {
        adjustTableHeight() {
            let pixelsToRemove = 500;
            // Check if the container has exactly one child div
            const container = document.querySelector('.page-header-top-container');
            if (container) {
                const childDivs = container.querySelectorAll('div');
                if (childDivs.length === 1) {
                    pixelsToRemove = 435; // Adjust based on the condition
                }
            }
            // Adjust height for all table wrappers
            const tableWrappers = document.querySelectorAll('.vgt-responsive');
            tableWrappers.forEach(tableWrapper => {
                const viewportHeight = window.innerHeight;
                // Ensure the height is not less than 500px
                tableWrapper.style.height = `${Math.max(500, viewportHeight - pixelsToRemove)}px`;
            });
        },
        getAllLocationList : function (from) {
            var page = (from != '' && typeof(from) != 'undefined') ? from : '';
            var self = this;
            var config = {
                //headers: {Authorization:localStorage.getItem("access_token")},
                params : {
                    from_page: page,
                }
            };
            HTTP.get('location-list', config)
                .then(function (response) {
                    //console.log('getAllLocationList', response);
                    if (response.status == '200') {
                        EventBus.$emit('all-location-list', response.data.location);
                    }
                })
                .catch(function (err) {
                    self.catchHandler(err);
                })
        },
        getAllStateList : function () {
            var self = this;
            var config = {
                //headers: {Authorization:localStorage.getItem("access_token")},
            };
            HTTP.get('state-list', config)
                .then(function (response) {
                    if (response.status == '200') {
                        EventBus.$emit('all-state-list', response.data.content);
                    }
                })
                .catch(function (err) {
                    self.catchHandler(err);
                })
        },
        getAllPermissions: function () {
            var self = this;

            var config = {
                headers: {
                    Authorization:localStorage.getItem("access_token")
                }
            };
            HTTP.get('get-all-permissions', config).
            then(response => {

                EventBus.$emit('all-permissions', false, response.data.content);

            })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.clear();
                            self.$router.push("/");
                        }
                        self.error = err.response.data.message;
                    }
                    this.catchHandler(err,true);
                });
        },
        getUserRole: function () {
            var self = this;
            var userObj = localStorage.getItem("user_obj");

            if (userObj != null) {
                var userJson = JSON.parse(userObj);
            }

            var fields = {
                user_id: userJson['id'],
            };
            var config = {
                headers: {
                    Authorization:localStorage.getItem("access_token")
                }
            };
            HTTP.post('get-login-id-role', fields, config).
            then(response => {

                EventBus.$emit('role', false, response.data.content.roles[0].id, response.data.content.roles[0].name);

            })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.clear();
                            self.$router.push("/");
                        }
                        self.error = err.response.data.message;
                    }
                    this.catchHandler(err,true);
                });
        },
        getUserPermissions: function () {
            var self = this;
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
            }
            var fields = {
                user_id: userJson['id'],
            };
            var config = {
                headers: {
                    Authorization:localStorage.getItem("access_token")
                }
            };
            HTTP.post('get-login-id-permissions', fields, config)
                    .then(response => {
                    var objData = {};
                    objData['id'] = 0;
                    objData['name'] = "dashboard";
                    response.data.content.user.permissions =  response.data.content.user.permissions.concat(objData);
                    EventBus.$emit('role', false, response.data.content.user.roles[0].id, response.data.content.user.roles[0].name);
                    EventBus.$emit('permissions', false, response.data.content.user.permissions);
                })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.clear();
                            self.$router.push("/");
                        }
                        self.error = err.response.data.message;
                    }
                    this.catchHandler(err,true);
                });
        },
        getRecords: function (currentPage1, perPage1, totalRecords1) {
            let serverPage = 0;
            let perPage = 0;
            let totalRecords = 0;
            var firstLoad = true;
            var firstRecord = 0;
            var lastRecord = 0;
            if (perPage1 == "All") {
                if (totalRecords1 == 0) {
                    firstRecord = 1;
                } else {
                    firstRecord = 1;
                }
                lastRecord = totalRecords1;
            } else {
                serverPage = Number(currentPage1);
                perPage = Number(perPage1);
                totalRecords = Number(totalRecords1);
                firstLoad = true;
                firstRecord = 0;
                lastRecord = 0;

                var page = serverPage;
                for (var i = 1; i <= page; i++) {
                    if (firstLoad == true) {
                        firstRecord = lastRecord + 1;
                        lastRecord = perPage;
                        firstLoad = false;
                    } else {
                        firstRecord = lastRecord + 1;
                        lastRecord = (perPage * i);
                    }
                }

                if (totalRecords != 0) {
                    if (lastRecord > totalRecords) {
                        lastRecord = totalRecords;
                    }
                } else if (totalRecords == 0) {
                    firstRecord = 0;
                    lastRecord = 0;
                }
            }
            return firstRecord + " - " + lastRecord;
        },
        getActiveMenu : function () {
            return self.activeMenu;
        },
        setActiveMenu : function (menu) {
            self.activeMenu = menu;
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
            $(".loading-container").hide();
            //}, 1700);
            /* let windowHeight = $(window).height();
            let headerHeight = $(".navbar-default").outerHeight();
            let contentHeight = $("#page-content-wrapper").outerHeight();
            let footerHeight = $(".admin-footer").outerHeight();
            if ((headerHeight + contentHeight) < windowHeight) {
                $(".admin-footer").css({"margin-top": Math.round(windowHeight - headerHeight - (contentHeight - footerHeight) - 10) + "px"});
            } else {
                $(".admin-footer").removeAttr("style");
            } */
        },
        catchHandler: function (err, callback) {
            var self = this;
            switch (err.response.status) {
                case 0:
                    this.showSAlert('Remote server cannot be reached', 'error', callback);
                    break;
                case 400:
                case 404:
                case 409:
                case 500:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 401:
                    localStorage.clear();
                    this.$router.push('/');
                    break;
                default:
                    this.showSAlert('Unexpected error occurred', 'error', callback);
                    break;
            }
        },
        showSAlert: function (message, type, callback) {
            this.$swal.fire(
                message,
                '',
                type
            );
            //callback("message");
        },
        hideShowHeaderFooter: function() {
            $('#main-header').show();
            $('#sidebar-wrapper').show();
            $("#wrapper").removeClass("login-div-full");
        },
        getUTCDateTime: function() {
            // var currentDate = new Date().toLocaleString();
            var currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
            var format = "YYYY-MM-DD HH:mm:ss";
            var currentTimezone = moment.tz.guess();

            var convertTimezone = moment.tz(currentTime, format, currentTimezone);
            convertTimezone.utc();
            var getConvertTime = convertTimezone.format("YYYY-MM-DD HH:mm:ss");
            return getConvertTime;
        },
        getUTCDiffTime: function(now, then) {
            var ms = moment(now, "YYYY-MM-DD HH:mm:ss").diff(moment(then, "YYYY-MM-DD HH:mm:ss"));
            var d = moment.duration(ms);
            var s = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
            // var s = moment.utc(moment(now, "YYYY-MM-DD HH:mm:ss").diff(moment(then, "YYYY-MM-DD HH:mm:ss"))).format("YYYY-MM-DD HH:mm:ss")
            return s;
        },
        formatString(data) {
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        customerProtal: function() {
            $('#main-header').show();
            $('#sidebar-wrapper').hide();
            $("#wrapper").addClass("login-div-full");
        },
        addNewLineInInovoiceColumn: function(invoice) {
            if(invoice != null && invoice != "") {
                let strInvoice = invoice.replaceAll(",", "<br/>");
                return strInvoice;
                /* let strInvoice = invoice.split(",");
                if(strInvoice.length > 1) {
                    return strInvoice[0] + ",\n" + strInvoice[1];
                }
                return invoice; */
                return strInvoice;
            } else {
                return "";
            }
        },
        stringTrim: function (string, length) {
            length = (typeof length !== 'undefined') ? length : 20;
            var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
            return string1;
        },
        validEmail : function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        /* Store and apply filters for different lists End */
        downloadFile: function (href) {
            if ($('#DynDownloadAnchor').length) {
                $('#DynDownloadAnchor').remove();
            }
            var anchor = document.createElement('a');
            anchor.id = "DynDownloadAnchor";
            anchor.style.display = "none";
            anchor.href = href;
            anchor.download = href;
            document.body.appendChild(anchor);
            anchor.click();
        },
        storeFilters: function (listType, pageFilters, clear) {
            if (typeof clear === 'undefined' || clear === null) {
                clear = false;
            }
            var getfilters = {};
            if (!clear) {
                var filterObj = localStorage.getItem("filters");
                if (filterObj != null) {
                    getfilters = JSON.parse(filterObj);
                }
            }
            getfilters[listType] = pageFilters;
            window.localStorage.setItem("filters", JSON.stringify(getfilters));
        },
        loadFilters: function (listType, columns, serverParams, listClass) {
            if (typeof listClass === 'undefined' || listClass === null) {
                listClass = '';
            }
            var appliedFilters = localStorage.getItem('filters');
            if (appliedFilters != null) {
                appliedFilters = JSON.parse(appliedFilters);
                if (appliedFilters[listType] != null) {
                    serverParams.sort = appliedFilters[listType].sort;
                    serverParams.page = appliedFilters[listType].page;
                    serverParams.perPage = appliedFilters[listType].perPage;
                    serverParams.setCurrentPage = appliedFilters[listType].setCurrentPage;
                    serverParams.columnFilters = appliedFilters[listType].columnFilters;
                    $.map(appliedFilters[listType].columnFilters, function (val, key) {
                        $.each(columns, function (i) {
                            if (columns[i].field == key && val != '') {
                                let el = $('.' + listClass + ' *[placeholder="' + columns[i].filterOptions.placeholder + '"]');
                                el.val(val);
                                columns[i].filterOptions.filterValue = val;
                            }
                        });
                    });
                }
            }
        },
        loadAllFilter: function(listType, listClass) {
            if (typeof listClass === 'undefined' || listClass === null) {
                listClass = '';
            }
            var appliedFilters = localStorage.getItem('filters');
            if (appliedFilters != null) {
                appliedFilters = JSON.parse(appliedFilters);
                if (appliedFilters[listType] != null) {
                    return appliedFilters[listType];
                }
            }
            return [];
        },
        setWidthToNoteContainer: function (time) {
            time = (time === null || typeof (time) === "undefined" || time == '') ? 300 : time;
            var screenWid = $(window).width();
            if (screenWid > 767) {
                setTimeout(function () {
                    var pageContent = $('.admin-page-content');
                    var pageContentSidePad = parseInt(pageContent.css('padding-right')) + parseInt(pageContent.css('padding-left'));
                    var contactDetail = $(".page-sidebar").outerWidth();
                    var sideMenu = $("#sidebar-wrapper").outerWidth();
                    if ($('.app-sidebar-right').attr('class').indexOf('toggled') != -1) {
                        sideMenu = 50;
                    }
                    $(".note-container").width(Math.ceil(screenWid - pageContentSidePad - contactDetail - sideMenu));
                }, time);
            }
        },
        menuTtoggleDesktop: function (from) {
            var self = this;
            $(".app-sidebar-right").toggleClass("toggled-2");
            if (from == 'dashboard') {
                self.setWidthToNoteContainer(550);
            }
        },
        getCustomerDetailById: function(id) {
            let config = {
                headers: {
                    // Authorization:localStorage.getItem("access_token")
                },
                params : {
                    id: id
                }
            };
            HTTP.get('fetch-logged-in-customer-permission', config)
                .then(response => {
                    if (!response.data.content.includes("backend_website")) {
                        localStorage.clear();
                        this.$router.push("/");
                    }
                    if (response.data.content.includes('view_only')) {
                        localStorage.setItem("view_only", true);
                    } else {
                        localStorage.setItem("view_only", false);
                    }
                })
                .catch(function (err) {
                    console.log(err)
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/commonMixins.js